export default __webpack_public_path__ + "static/media/ic-calendarsync.402b9952.svg";